import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { AuthGuard } from './services/auth.guard';

const routes: Routes = [
    { path: 'login-normal', redirectTo: '', pathMatch: 'full' },
    { path: '', loadChildren: () => import('./pages/public/login-normal/login-normal.module').then(m => m.LoginNormalPageModule) },

    { path: 'login-normal', loadChildren: () => import('./pages/public/login-normal/login-normal.module').then(m => m.LoginNormalPageModule) },
    { path: 'logging-out', loadChildren: () => import('./pages/private/logging-out/logging-out.module').then(m => m.LoggingOutPageModule), canActivate: [AuthGuard] },
    { path: 'register', loadChildren: () => import('./pages/public/register/register.module').then(m => m.RegisterPageModule) },
    { path: 'application-reference', loadChildren: () => import('./pages/public/application-reference/application-reference.module').then(m => m.ApplicationReferenceModule)},
    { path: 'confirm-email', loadChildren: () => import('./pages/public/confirm-email/confirm-email.module').then(m => m.ConfirmEmailPageModule) },
    { path: 'recover', loadChildren: () => import('./pages/public/recover/recover.module').then(m => m.RecoverPageModule) },
    { path: 'welcome', loadChildren: () => import('./pages/public/welcome/welcome.module').then(m => m.WelcomePageModule) },
    { path: 'walkthrough', loadChildren: () => import('./pages/public/walkthrough/walkthrough.module').then(m => m.WalkthroughPageModule) },
    { path: 'bad-api-version', loadChildren: () => import('./pages/public/bad-api-version/bad-api-version.module').then(m => m.BadApiVersionPageModule)},
    {
        path: 'groups',
        loadChildren: () => import('./pages/private/tab-groups/tab-groups.module').then(m => m.TabGroupsPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'channels',
        loadChildren: () => import('./pages/private/channels/channels.module').then(m => m.ChannelsPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'training',
        loadChildren: () => import('./pages/private/training/training.module').then(m => m.TrainingPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'profile',
        loadChildren: () => import('./pages/private/profile/profile.module').then(m => m.ProfilePageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'seekers',
        loadChildren: () => import('./pages/private/seekers/seekers.module').then(m => m.SeekersPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'chats',
        loadChildren: () => import('./pages/private/chats/chats.module').then(m => m.ChatsPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'tab-home',
        loadChildren: () => import('./pages/private/tab-home/tab-home.module').then(m => m.TabHomePageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'application',
        loadChildren: () => import('./pages/private/application/application.module').then(m => m.ApplicationPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'training-detail',
        loadChildren: () => import('./pages/private/training-detail/training-detail.module').then(m => m.TrainingDetailPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'calendar',
        loadChildren: () => import('./pages/private/calendar/calendar.module').then(m => m.CalendarPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'calendar-event',
        loadChildren: () => import('./pages/private/calendar-event/calendar-event.module').then(m => m.CalendarEventPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'seeker-request',
        loadChildren: () => import('./pages/private/seeker-request/seeker-request.module').then(m => m.SeekerRequestPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'seeker-profile',
        loadChildren: () => import('./pages/private/seeker-profile/seeker-profile.module').then(m => m.SeekerProfilePageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'group-messages',
        loadChildren: () => import('./pages/private/group-messages/group-messages.module').then(m => m.GroupMessagesPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'home',
        loadChildren: () => import('./pages/private/landing/landing.module').then(m => m.LandingPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'notifications',
        loadChildren: () => import('./pages/private/notifications/notifications.module').then(m => m.NotificationsPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'contact-form',
        loadChildren: () => import('./pages/private/contact-form/contact-form.module').then(m => m.ContactFormPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'training-quiz',
        loadChildren: () => import('./pages/private/training-quiz/training-quiz.module').then(m => m.TrainingQuizPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'training-seeker-chat',
        loadChildren: () => import('./pages/private/training-seeker-chat/training-seeker-chat.module').then(m => m.TrainingSeekerChatPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'training-seekers-select',
        loadChildren: () => import('./pages/private/training-seekers-select/training-seekers-select.module').then(m => m.TrainingSeekersSelectPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'resources',
        loadChildren: () => import('./pages/private/resources/resources.module').then(m => m.ResourcesPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'account-block-page',
        loadChildren: () => import('./pages/public/account-block-page/account-block-page.module').then(m => m.AccountBlockPagePageModule)
    },
    {
        path: 'admin-om-chat',
        loadChildren: () => import('./pages/private/admin-om-chat/admin-om-chat.module').then(m => m.AdminOmChatPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'admin-om-chat-messages',
        loadChildren: () => import('./pages/private/admin-om-chat-messages/admin-om-chat-messages.module').then(m => m.AdminOmChatMessagesPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'collect-testimony',
        loadChildren: () => import('./pages/public/collect-testimony/collect-testimony.module').then(m => m.CollectTestimonyPageModule)
    },
    {
        path: 'landing',
        loadChildren: () => import('./pages/private/landing/landing.module').then(m => m.LandingPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'contact-leader',
        loadChildren: () => import('./pages/private/contact-leader/contact-leader.module').then(m => m.ContactLeaderPageModule)
    },

    {
        path: 'seekers-pool',
        loadChildren: () => import('./pages/private/seekers-pool/seekers-pool.module').then(m => m.SeekersPoolPageModule)
    },
    {
        path: 'resources-templates',
        loadChildren: () => import('./pages/private/resources/resources-templates/resources-templates.module').then(m => m.ResourcesTemplatesPageModule)
    },
    {
        path: 'resources-documents',
        loadChildren: () => import('./pages/private/resources/resources-documents/resources-documents.module').then(m => m.ResourcesDocumentsPageModule)
    },
    {
        path: 'resources-helpful-links',
        loadChildren: () => import('./pages/private/resources/resources-helpful-links/resources-helpful-links.module').then(m => m.ResourcesHelpfulLinksPageModule)
    },
    {
        path: 'archive-contacts',
        loadChildren: () => import('./pages/private/archive-contacts/archive-contacts.module').then(m => m.ArchiveContactsPageModule)
    },
    //   { path: 'view-application', loadChildren: './pages/private/view-application/view-application/view-application.module#ViewApplicationPageModule' },
    {
        path: 'view-application',
        loadChildren: () => import('./pages/private/view-application/view-application.module').then(m => m.ViewApplicationPageModule),
        canActivate: [AuthGuard]
    },
    { path: 'bible-chapter', loadChildren: () => import('./pages/private/resources/bible-chapter/bible-chapter.module').then(m => m.BibleChapterPageModule) },
    { path: 'shared-verses', loadChildren: () => import('./pages/private/resources/shared-verses/shared-verses.module').then(m => m.SharedVersesPageModule) },
    { path: 'view-testimony', loadChildren: () => import('./pages/private/view-testimony/view-testimony.module').then(m => m.ViewTestimonyPageModule) },
    { path: 'support', loadChildren: () => import('./pages/private/support/support.module').then(m => m.SupportPageModule) },




    // {path: '**', redirectTo: 'login-normal'},
];

@NgModule({
    imports: [IonicModule.forRoot({ swipeBackEnabled: false }), RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
